import { observer } from 'mobx-react-lite'
import { Box, Button, Icon, SpinnerLoader, Typography } from 'shared/ui'
import { LINK_VOICEMAIL_DROP } from 'shared/constants/links'
import { AddVoicemailAudioButton } from 'pages/settings/pages/personal/pages/account/pages/voicemailDrop/ui/AddVoicemailAudioButton/AddVoicemailAudioButton'
import { useVoicemailDropContext } from 'pages/settings/pages/personal/pages/account/pages/voicemailDrop/context/voicemailDropContext'
import styles from './styles.module.scss'

export const VoicemailDropEmpty = observer(() => {
  const store = useVoicemailDropContext()

  if (store.loading) return <SpinnerLoader ariaLabel={'VoicemailDropEmptyPage'} />

  return (
    <div className={styles.emptyPage}>
      <div className={styles.emptyWrap}>
        <Box display={'flex'} justifyContent={'center'}>
          <Icon icon={'voicemail2'} color={'var(--content-brand-primary)'} fontSize={40} />
        </Box>
        <Typography
          variant={'heading-lg'}
          ariaLabel={'Voicemail drop'}
          tag={'div'}
          marginTop={32}
          marginBottom={8}
        >
          Voicemail drop
        </Typography>
        <Box padding={'0 10px'}>
          <Typography
            variant={'body-lg-regular'}
            ariaLabel={'Voicemail drop description'}
            tag={'div'}
            color={'var(--content-primary-tertiary)'}
            marginBottom={32}
            style={{ padding: '0 10px' }}
          >
            Drop prerecorded audio into voicemail when calls aren’t answered
          </Typography>
        </Box>
        <Box display={'grid'} gridTemplateColumns={'1fr 1fr'} gap={'8px'}>
          <AddVoicemailAudioButton store={store} />

          <Button
            fullWidth
            tag='a'
            text='Help guide'
            size='medium'
            contained='tertiary'
            style={{ textDecoration: 'none' }}
            href={LINK_VOICEMAIL_DROP}
            target='_blank'
            rel='noreferrer'
            iconProps={{ icon: 'info' }}
          />
        </Box>
      </div>
    </div>
  )
})
